export default {
  sizes: [
    '10x20',
    '11x14',
    '12x16',
    '18x24',
    '19.5x70',
    '20x16',
    '23x23',
    '24x18',
    '24x48',
    '30x20',
    '30x24',
    '36x24',
    '36x30',
    '40x30',
    '48x36',
  ],
  colors: [
    'white',
    'black',
    'grey',
    'red',
    'green',
    'blue',
    'orange',
    'yellow',
    'silver',
    'gold',
    'brown',
    'purple',
    'pink',
  ],
  textures: ['glitter', 'crystals', 'multimedia', 'other'],
  topCoats: ['gloss', 'matte', 'resin'],
};
